import { defineProperty as _defineProperty } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { cssClassPrefix } from '../../../shared/constants/generalConstants.js';
import { isEnterKeyPressed, isSpaceKeyPressed } from '../../../shared/utils/keysUtils.js';

var BASE_CSS = "".concat(cssClassPrefix, "-header-title");

/**
 * IlHeaderTitle Component
 * ```javascript
 * <IlHeaderTitle title="" onClick={() => void}/>
 * ```
 */
var IlHeaderTitle = function IlHeaderTitle(props) {
  var title = props.title,
    onClick = props.onClick,
    _props$isVisibleInMob = props.isVisibleInMobile,
    isVisibleInMobile = _props$isVisibleInMob === void 0 ? true : _props$isVisibleInMob;
  var classes = classNames(BASE_CSS, _defineProperty({}, "".concat(cssClassPrefix, "-header--clickable"), onClick), _defineProperty({}, "".concat(BASE_CSS, "-hidden--mobile"), !isVisibleInMobile));
  var onKeyPressHandler = function onKeyPressHandler(e) {
    // For accessability
    if (isEnterKeyPressed(e) || isSpaceKeyPressed(e)) {
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: classes,
    role: "button",
    onKeyPress: onKeyPressHandler,
    onClick: onClick || null,
    tabIndex: 0
  }, typeof title === 'string' && /*#__PURE__*/React__default.createElement("h1", {
    className: "".concat(BASE_CSS, "__heading")
  }, title), typeof title !== 'string' && title);
};
IlHeaderTitle.propTypes = {
  title: PropTypes.node,
  onClick: PropTypes.func,
  isVisibleInMobile: PropTypes.bool
};

export { IlHeaderTitle as default };
